export const SETNOTIFICATIONCOUNT = "SETNOTIFICATIONCOUNT";
